import { gql } from '@apollo/client';

export const INVITE_TEAM_MEMBER = gql`
  mutation InviteTeamMember($clientId: String!, $email: String!, $role: ClientRole!) {
    inviteTeamMember(clientId: $clientId, email: $email, role: $role) {
      success
      message
      pendingMember {
        user {
          _id
          email
        }
        role
        status
        invitedAt
      }
    }
  }
`;

export const ACCEPT_INVITATION_WITH_TOKEN = gql`
  mutation AcceptInvitationWithToken(
    $token: String!
    $password: String
    $firstName: String
    $lastName: String
  ) {
    acceptInvitationWithToken(
      token: $token
      password: $password
      firstName: $firstName
      lastName: $lastName
    ) {
      success
      message
      authToken
      user {
        _id
        email
        firstName
        lastName
      }
    }
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation AcceptInvitation($clientId: String!) {
    acceptInvitation(clientId: $clientId) {
      success
      message
    }
  }
`;

export const DECLINE_INVITATION = gql`
  mutation DeclineInvitation($clientId: String!) {
    declineInvitation(clientId: $clientId) {
      success
      message
    }
  }
`;

export const REMOVE_TEAM_MEMBER = gql`
  mutation RemoveTeamMember($clientId: String!, $userId: String!) {
    removeTeamMember(clientId: $clientId, userId: $userId) {
      success
      message
    }
  }
`;

export const UPDATE_TEAM_MEMBER_ROLE = gql`
  mutation UpdateTeamMemberRole($clientId: String!, $userId: String!, $newRole: ClientRole!) {
    updateTeamMemberRole(clientId: $clientId, userId: $userId, newRole: $newRole) {
      success
      message
    }
  }
`;

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($clientId: String!, $userId: String!) {
    resendInvitation(clientId: $clientId, userId: $userId) {
      success
      message
    }
  }
`;

export const TRANSFER_OWNERSHIP = gql`
  mutation TransferOwnership($clientId: String!, $newOwnerId: String!) {
    transferOwnership(clientId: $clientId, newOwnerId: $newOwnerId) {
      success
      message
    }
  }
`;

export const LEAVE_CLIENT = gql`
  mutation LeaveClient($clientId: String!) {
    leaveClient(clientId: $clientId) {
      success
      message
    }
  }
`;
